
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { PromiseStatus } from '@/data/promises';
import { cn } from '@/lib/utils';

interface StatusBadgeProps {
  status: PromiseStatus;
  className?: string;
}

const StatusBadge = ({ status, className }: StatusBadgeProps) => {
  const getStatusColor = (status: PromiseStatus) => {
    switch (status) {
      case 'fulfilled':
        return 'bg-status-fulfilled hover:bg-status-fulfilled/90';
      case 'ongoing':
        return 'bg-status-ongoing hover:bg-status-ongoing/90';
      case 'broken':
        return 'bg-status-broken hover:bg-status-broken/90';
      case 'unknown':
      default:
        return 'bg-status-unknown hover:bg-status-unknown/90';
    }
  };

  const getStatusText = (status: PromiseStatus) => {
    switch (status) {
      case 'fulfilled':
        return 'Fulfilled';
      case 'ongoing':
        return 'Ongoing';
      case 'broken':
        return 'Broken';
      case 'unknown':
      default:
        return 'Unknown';
    }
  };

  return (
    <Badge className={cn(getStatusColor(status), className)}>
      {getStatusText(status)}
    </Badge>
  );
};

export default StatusBadge;
